export const getShortPhone = (phone: string = ""): string =>
  phone?.replace(/[\(\) ]/gm, "") ?? "";
